import { REGION_VARIANTS, TRegionVariant } from 'constants/region';

export const isValidRegionVariant = (
  value: string | undefined,
): value is TRegionVariant => {
  return Object.values(REGION_VARIANTS).includes(value as TRegionVariant);
};
